export function parseUtcDateStringToMs(value?: string | null): number | null {
  if (!value) {
    return null;
  }

  const trimmed = value.trim();
  const hasTz = /Z$|[+-]\d{2}:\d{2}$/.test(trimmed);
  const normalized = hasTz ? trimmed : `${trimmed}Z`;
  const parsed = Date.parse(normalized);

  return Number.isFinite(parsed) ? parsed : null;
}
